import { FC } from "react";
import { SupplierLoginWrap } from "./style";
import { App, Button, Form, Input } from "antd";
import { useNavigate } from "react-router-dom";
import { ROUTER_KEYS } from "@/router/routers";

import apis from '@/apis/supplier'
import { useTranslation } from "react-i18next";
import { clearStorage, setStorage } from "@/utils/storage";
interface FieldType {
  account?: string;
  password?: string;
}

const SupplierLogin: FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { notification } = App.useApp();

  const onFinish = (values: FieldType) => {
    clearStorage();
    apis.supplierLogin(values.account || '', values.password || '')
      .then((res) => {
        setStorage('SUPPLIER_ACCESS_TOKEN', res.accessToken);
        setStorage('SUPPLIER_REFRESH_TOKEN', res.refreshToken);
        navigate(ROUTER_KEYS.SUPPLIER_REQUEST_HOME + '?pageType=pending', {replace: true});
      })
      .catch((err) => {
        console.log('登录失败');
        const map: {
          [key in number]: string;
        } = {
          10010: t("supplierLayout.networkError"),
          70205: t("login.acntNotExist"),
          // 70207: t("sale.账号已存在"),
          71603: t("supplierLayout.acntNotAvailable"),
          70208: t("supplierLayout.accountErr"),
        };

        notification.error({ placement: 'top',
          message: t("supplierLayout.loginFail"),
          description: map[err] ?? t("common.serverError"),
        });
      })
  }

  return (
    <SupplierLoginWrap vertical align="center" justify="center">
      <div className="login--title">{t('supplierLayout.loginTitle')}</div>
      <div className="login--container">
        <Form
          name="basic"
          size='large'
          labelCol={{ span: 8 }}
          wrapperCol={{ span: 16 }}
          style={{ maxWidth: 800 }}
          initialValues={{ remember: true }}
          onFinish={onFinish}
          // onFinishFailed={onFinishFailed}
          autoComplete="off"
          colon={false}
        >
          <Form.Item<FieldType>
            label="Account"
            name="account"
            rules={[{ required: true, message: t('supplierLayout.inputAct') }]}
          >
            <Input />
          </Form.Item>

          <Form.Item<FieldType>
            label="Password"
            name="password"
            rules={[{ required: true, message: t('supplierLayout.inputPwd') }]}
          >
            <Input.Password />
          </Form.Item>

          <Form.Item label={<></>}>
            <Button style={{ width: "100%" }} type="primary" htmlType="submit">
              {t('supplierLayout.login')}
            </Button>
          </Form.Item>
        </Form>
      </div>
    </SupplierLoginWrap>
  );
};

export default SupplierLogin;
